<template>
  <div class="uyh-landing-container">
    <p>{{ $t('intro_message') }}</p>
    <router-link @click.native="$emit('step-update', 'learn-how')" to="learn-how">{{ $t('learn_how') }}</router-link>
    <router-link @click.native="$emit('step-update', 'get-started')" to="get-started">{{ $t('get_started') }}</router-link>
  </div>
</template>

<style lang="scss" scoped>
  .responsivesite #wrapper #uyh-app,
  #uyh-app {
    .uyh-landing-container {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      margin: 0 auto;
      max-width: 500px;
      p {
        flex: 1 0 100%;
        font-size: 20px;
        line-height: 1.4;
        margin: 0;
        padding: 31px 24px 0;
        text-align: center;
      }
      a {
        flex: 0 0 auto;
        font-size: 20px;
        letter-spacing: 1px;
        line-height: normal;
        padding-top: 22px;
      }
    }
  }
</style>

<script>
  export default {
    name: "landing",
    mounted: function() {
      this.$emit('step-update', 'landing');
      this.$nextTick(function(){
        this.$emit('component-height');
      });
    }
  }
</script>
